import React from "react";

import { defaultPaperworkBackgroundData } from "@constants/PatientFormConstants";

import { FormContainer } from "../../common/FormContainer";
import { steps } from "./steps";

interface DetailsFormProps {
  patientId: string;
}

/**
 * Patient Details Container
 *
 * This component serves as a container for patient details forms.
 * It provides the FormOrchestrator context and renders the form steps.
 */
const DetailsForm: React.FC<DetailsFormProps> = ({ patientId }) => {
  return (
    <FormContainer
      title="Patient Details"
      description="Please make sure the information in these sections is correct."
      formType="details"
      patientId={patientId}
      steps={steps}
      defaultValues={defaultPaperworkBackgroundData}
    />
  );
};

export default DetailsForm;
